import Nora from '@primeng/themes/nora';
export const environment = {
    production: true,
    base: `/api/v1`,
    smbServer: '192.168.1.180',
    calendar: false,
    digitsInfo: '1.1-4',
    layout: 'x',
    theme: Nora,
    primary: 'sky',
    secondary: 'graphite',
    tertiary: 'lime',
    title: 'PrintCore',
};
